import type { Language } from '../../i18n/translations.js';
import { DEMO_COPY } from './demo-copy.js';
import type { DemoMedia } from './useDemoMedia.js';
import type { DemoExample } from './demo-media.js';
export function VideoChoiceStage({
  language,
  step,
  onChoose,
  media,
}: {
  readonly language: Language;
  readonly step: number;
  readonly onChoose: (example: DemoExample) => void;
  readonly media: DemoMedia;
}) {
  const c = DEMO_COPY[language];
  return (
    <section
      className="stage mw-stage mw-videos-stage"
      id="stage-2"
      aria-labelledby="video-title"
      hidden={step !== 2}
    >
      <div className="mw-stage-heading">
        <h3 id="video-title" tabIndex={-1}>
          {c.chooseAViralVideo}
        </h3>
      </div>
      <div className="mw-guide mw-video-guide" id="video-guide">
        <span className="mw-guide-dot" aria-hidden="true"></span>
        <p>{c.weLlRemakeItWithYour}</p>
      </div>
      <div className="video-grid">
        <article className="video-card available">
          <div className="card-media">
            <video
              id="choice-source"
              poster="/landing-demo/source.jpg"
              muted
              playsInline
              preload="none"
              aria-label={c.previewTheOriginalDrinkVideo}
              ref={media.refs.source}
              onError={media.fail}
              onPlay={media.sync}
              onPause={media.sync}
            ></video>
            <span
              className="media-badge active"
              aria-label={c.viewCountLabel}
              title="Recorded 3 Nov 2026 · رُصدت في ٣ نوفمبر ٢٠٢٦"
            >
              {c.label17MViews}
            </span>
            <button
              className="preview-play"
              type="button"
              onClick={() => void media.preview('source')}
              aria-pressed={media.previewPlaying === 'source'}
              aria-label={`${media.previewPlaying === 'source' ? c.pauseLabel : c.playLabel} ${c.theUnexpectedTreat}`}
            >
              <span aria-hidden="true">
                {media.previewPlaying === 'source' ? 'Ⅱ' : '▶'}
              </span>
            </button>
          </div>
          <div className="card-body">
            <h4>{c.theUnexpectedTreat}</h4>
            <button
              className="btn"
              id="use-video"
              aria-label={`${c.useThisVideo}: ${c.theUnexpectedTreat}`}
              aria-describedby="video-guide"
              type="button"
              onClick={() => {
                onChoose('drink');
              }}
            >
              <span className="cs-px3" aria-hidden="true">
                <i></i>
                <i></i>
                <i></i>
              </span>
              <span>{c.useThisVideo}</span>
              <span className="arrow" aria-hidden="true">
                {'→'}
              </span>
            </button>
          </div>
        </article>
        <article className="video-card available">
          <div className="card-media">
            <video
              id="choice-magic"
              poster="/landing-demo/magic.jpg"
              muted
              playsInline
              preload="none"
              aria-label={c.previewCroissantVideo}
              ref={media.refs.magic}
              onError={media.fail}
              onPlay={media.sync}
              onPause={media.sync}
            ></video>
            <span
              className="media-badge active"
              aria-label={c.croissantViewsLabel}
              title={c.croissantViewsLabel}
            >
              {c.croissantViews}
            </span>
            <button
              className="preview-play"
              type="button"
              onClick={() => void media.preview('magic')}
              aria-pressed={media.previewPlaying === 'magic'}
              aria-label={`${media.previewPlaying === 'magic' ? c.pauseLabel : c.playLabel} ${c.aLittleMagic}`}
            >
              <span aria-hidden="true">
                {media.previewPlaying === 'magic' ? 'Ⅱ' : '▶'}
              </span>
            </button>
          </div>
          <div className="card-body">
            <h4>{c.aLittleMagic}</h4>
            <button
              className="btn"
              id="use-croissant"
              aria-label={`${c.useThisVideo}: ${c.aLittleMagic}`}
              aria-describedby="video-guide"
              type="button"
              onClick={() => {
                onChoose('croissant');
              }}
            >
              <span className="cs-px3" aria-hidden="true">
                <i></i>
                <i></i>
                <i></i>
              </span>
              <span>{c.useThisVideo}</span>
              <span className="arrow" aria-hidden="true">
                {'→'}
              </span>
            </button>
          </div>
        </article>
        <article className="video-card">
          <div className="card-media">
            <video
              id="choice-travel"
              poster="/landing-demo/travel.jpg"
              muted
              playsInline
              preload="none"
              aria-label={c.somewhereExtraordinaryTravelCollectionPreview}
              ref={media.refs.travel}
              onError={media.fail}
              onPlay={media.sync}
              onPause={media.sync}
            ></video>
            <span className="media-badge">{c.previewOnly}</span>
            <button
              className="preview-play"
              type="button"
              onClick={() => void media.preview('travel')}
              aria-pressed={media.previewPlaying === 'travel'}
              aria-label={`${media.previewPlaying === 'travel' ? c.pauseLabel : c.playLabel} ${c.somewhereExtraordinary}`}
            >
              <span aria-hidden="true">
                {media.previewPlaying === 'travel' ? 'Ⅱ' : '▶'}
              </span>
            </button>
          </div>
          <div className="card-body">
            <h4>{c.somewhereExtraordinary}</h4>
          </div>
        </article>
      </div>
    </section>
  );
}
